import { render } from "./MonthData.vue?vue&type=template&id=59f83c3e&ts=true"
import script from "./MonthData.vue?vue&type=script&lang=ts"
export * from "./MonthData.vue?vue&type=script&lang=ts"

import "./MonthData.vue?vue&type=style&index=0&id=59f83c3e&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__